export default __webpack_public_path__ + "static/media/WNo.8-5.5add14d1.jpg";